module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Left Chaise_Stone.d1966514.png";